import React from 'react'
import ImageComponent from './image'

const SectionProfilesComponent = props =>
    <div className="section--primary" id="team">
        <div className="section__grid">
        <div className="section__img u-text-center">
        <ImageComponent image="sheep" />
    </div>

            <div className="section__text">
            <h2>Organisers</h2>
                <div>
                    <p>
                        <strong>Veronica Aniceti</strong>
                        <br /><small>
                            PhD student in Zooarchaeology at the University of Sheffield (UK).<br />Her research project is focused on animal husbandry in Sicily during the medieval period (7<sup>th</sup> – 13<sup>th</sup> centuries AD).</small>
                    </p>
                </div>
                <div>
                    
                    <p><strong>Matteo Bormetti</strong>
                    <br /><small>
                        MSc Osteoarchaelogy at the University of Sheffield (UK).<br />His research focuses on animal husbandry and waste disposal practices in Italy and Britain during the Iron Age.</small>
                    </p>
                </div>
                <div>
                    
                    <p><strong>Mauro Rizzetto</strong>
                    <br /><small>
                    PhD student at the University of Sheffield (UK).<br />His research deals with the development of animal husbandry during the late Roman - early medieval transition in Britain and in the lower Rhineland, with particular regard to biometrical changes.</small>
                    </p>
                </div>
            </div>
        </div>
    </div>

export default SectionProfilesComponent



// WEBPACK FOOTER //
// ./src/components/section-profiles.js